import { useEffect } from 'react'
import { ToastOptions, toast } from 'react-hot-toast'
import { Trans, useTranslation } from 'next-i18next'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import useUser from 'shared/hooks/use-user'
import { InfoIcon } from 'shared/icons/info-icon'
import { buildDashboardUrl } from 'modules/white-label/utils/dashboard-url'

const RESTRICTED_ID = 'restricted-access-toast'
const baseOptions: ToastOptions = {
  id: RESTRICTED_ID,
  duration: Infinity,
}

export const useRestrictedAccessNotification = () => {
  const { t } = useTranslation()
  const { isAccessRestricted } = useUser()

  useEffect(() => {
    if (isAccessRestricted) {
      toast.error(
        <Trans
          t={t}
          i18nKey="global.account_restricted.notification"
          components={{
            a: (
              <LinkWithoutPrefetch
                href={buildDashboardUrl('/profile/user-plan')}
                className="primary-link hover:text-brand-primary-hover"
              />
            ),
          }}
        />,
        {
          className: 'min-w-fit text-sm border-danger border !text-danger !bg-red/10',
          icon: <InfoIcon className="shrink-0" />,
          ...baseOptions,
        },
      )
    }
  }, [isAccessRestricted])
}
